import React, { useMemo } from 'react';

import CitiesMap from 'components/CitiesMap';
import NeighborhoodsMap from 'components/NeighborhoodsMap';
import useLiveData from 'hooks/useLiveData';
import { useNeighborhoodsMapQuery } from 'hooks/useNeighborhoodsMapQuery';

const NeighborhoodsMapProvider = ({ id, staticData, mapProps = {} }) => {
    const { data } = useNeighborhoodsMapQuery();
    const shouldLimitLiveDataByStaticIds = !staticData;
    const effectiveStaticData = React.useMemo(() => staticData || data || {}, [staticData, data]);
    const neighborhoodsMapEdges = effectiveStaticData?.allSmartTagsNeighborhoodsMap?.edges || [];
    const neighborhoodsMapNodes = neighborhoodsMapEdges.map(({ node }) => node);

    const {
        statusText: neighborhoodsMapStatusText,
        response: neighborhoodsMapResponse,
        visibilityChange: neighborhoodsMapVisibilityChange,
    } = useLiveData({
        namespace: 'SmartTags',
        model: 'NeighborhoodsMap',
        method: 'all',
        graphqlKey: 'allSmartTagsNeighborhoodsMap',
        apiParams: {
            archived: false,
            approved: true,
            deleted: false,
            ...(shouldLimitLiveDataByStaticIds && neighborhoodsMapNodes.length > 0 ? {
                id: neighborhoodsMapNodes.map((n) => n.id).join(','),
            } : {}),
            ...(!!id ? { id: id } : {}),
        },
        staticData: effectiveStaticData,
    });

    const liveNeighborhoodsMap = !!id ? neighborhoodsMapResponse?.data.find((n) => n.id === id) : neighborhoodsMapResponse?.data[0];
    let neighborhoodsMap = !!id ? neighborhoodsMapNodes.find((n) => n.id === id) : neighborhoodsMapNodes[0];
    if (!!liveNeighborhoodsMap && neighborhoodsMapStatusText === 'LOADED') {
        neighborhoodsMap = liveNeighborhoodsMap;
    }
    if (!!liveNeighborhoodsMap && neighborhoodsMapVisibilityChange) neighborhoodsMap = liveNeighborhoodsMap;

    const datum = useMemo(() => neighborhoodsMap, [neighborhoodsMap]);
    const mapType = String(datum?.type || '').trim().toLowerCase();
    const MapComponent = mapType === 'cities-map' ? CitiesMap : NeighborhoodsMap;

    return (
        <MapComponent {...datum} {...mapProps} />
    );
};

export default NeighborhoodsMapProvider;